import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import chatService from "../../../services/ChatService";
import brainService from "../../../services/BrainService";
import ButtonAction from "/src/components/UI/Button/Button";
import "../../../css/ChatInput.css";

function ChatInput({ brainId, onQuestionSent, isLoading }) {
    const { chatId } = useParams();
    const [message, setMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [brainName, setBrainName] = useState(null);
    const toast = useToastDispatchContext();

    useEffect(() => {
        const fetchBrain = async (params) => {
            try {
                const [response, error] = await brainService.getBrain(brainId);
                if (error) return [null, error];
                setBrainName(response.name);
            } catch (error) {
                return [null, error];
            }
        };

        if (brainId) {
            fetchBrain();
        }
    }, [brainId, toast]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!message.trim()) return;

        setIsSubmitting(true);

        try {
            const [response, error] = await chatService.askQuestion(chatId, brainId, message);
            if (error) {
                toast.error("Error", "Failed to submit the question.");
                console.error("Error submitting question:", error);
            } else {
                setMessage("");
                onQuestionSent();
            }
        } catch (err) {
            toast.error("Error", "An unexpected error occurred.");
            console.error("Unexpected error submitting question:", err);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="chat-input-container">
                <CurrentBrainDisplay brainName={brainName} />
                <div className="chat-editor-wrapper">
                    <input
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Type your message here..."
                        className="chat-input"
                    />
                    <ButtonAction
                        type="submit"
                        className="chat-submit-button button validate"
                        label={isSubmitting || isLoading ? "Submitting..." : "Send"}
                        disabled={isSubmitting || isLoading || !message.trim()}
                    />
                </div>
            </div>
        </form>
    );
}

function CurrentBrainDisplay({ brainName }) {
    return (
        <div className="current-brain-display">
            <span>Talking to {brainName || "Current Brain"}</span>
        </div>
    );
}

export default ChatInput;
